import React,{ useState , useEffect} from 'react';

//! CSS:
import '../styles/Sidebar.css';
import 'rsuite/dist/rsuite.min.css';
import { FaCity } from "react-icons/fa";
import { Divider } from '@mui/joy';
import { Sidenav, Nav, Tooltip } from 'rsuite';
import { FaVectorSquare } from "react-icons/fa6";
import { MdDashboard } from "react-icons/md";
import { LuGalleryHorizontalEnd } from "react-icons/lu";

import { RiCalendarScheduleLine } from "react-icons/ri";
import { GrVmMaintenance } from "react-icons/gr";
import { MdAutoFixHigh } from "react-icons/md";
import { BsFillBuildingsFill } from "react-icons/bs";
import { SiMockserviceworker, SiTestcafe } from "react-icons/si";
import { CgComponents } from "react-icons/cg";
import { BsBuildingX } from "react-icons/bs";
import { TbReportAnalytics } from "react-icons/tb";
import { AiOutlineAudit } from "react-icons/ai";
import { TbPresentationAnalytics } from "react-icons/tb";
import { GrCompliance } from "react-icons/gr"; 
import { PiSpinnerGapBold } from "react-icons/pi";
import { MdOutlineMiscellaneousServices } from "react-icons/md";
import { PiMicrosoftTeamsLogoFill } from "react-icons/pi";
import { SiGithubactions } from "react-icons/si";
import { GiMoneyStack, GiTakeMyMoney } from "react-icons/gi";
import { VscProject } from "react-icons/vsc";
import { TbReport } from "react-icons/tb";
import { TbBusinessplan } from "react-icons/tb";
import { GiExpense } from "react-icons/gi";
import { MdOutlineAttachMoney } from "react-icons/md";
import { MdConstruction } from "react-icons/md";
import { GiDuration } from "react-icons/gi";
import { GoProjectSymlink } from "react-icons/go";
import { VscMilestone } from "react-icons/vsc";
import { LuCalendarCheck2 } from "react-icons/lu";
//
import { TbTruckDelivery } from "react-icons/tb";
import { TbSettingsCheck } from "react-icons/tb";
import { RiProjectorFill } from "react-icons/ri";
import { Cascader } from 'rsuite';
import { FaBuilding, FaCog, FaLeaf, FaHistory, FaPlus, FaExpandArrowsAlt } from 'react-icons/fa';
//
import { FiBarChart2 } from "react-icons/fi";
import { GiNetworkBars } from "react-icons/gi";
import { IoInfinite } from "react-icons/io5";
import { MdInventory } from "react-icons/md";
import { NavLink, useLocation,Navigate } from 'react-router-dom';
//
import { FaTasks } from "react-icons/fa";

import { RiUserAddFill } from "react-icons/ri";
import { FaUserCog } from "react-icons/fa";
import { FaUsers } from "react-icons/fa";
import { FaUsers as Us } from "react-icons/fa6";
import { MdWorkspacesFilled } from "react-icons/md";
import { FaUserShield } from "react-icons/fa6";
import { IoSettings } from "react-icons/io5";
import { useTranslation } from 'react-i18next';
import { Popover, Whisper, Button, Dropdown } from 'rsuite';
import { hasPermission } from './CheckPermissions';
import { IoMdDoneAll } from "react-icons/io";
export default function Sidebar({onToggle,background,theme}) {
    const [expanded, setExpanded] = React.useState(true);
    const [activeKey, setActiveKey] = React.useState('1');


    const user=JSON.parse(localStorage.getItem('user'));
    const token=localStorage.getItem('token');
    const {t } = useTranslation();

    const [settingsFetched,setSettingsFetched]=useState([]);
    const [temp, setTemp] = useState('');

    useEffect(()=>{
        try {
            fetch(`${process.env.REACT_APP_API_URL}/api/auth/settings`, {
                method: 'GET',
                headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                },
            }).then((response)=>response.json())
            .then((result)=>{
                setSettingsFetched(result.settings);
                // if(settingsFetched>0){
                    setTemp(result.settings[0]?.timezone);
                // }
            })
        }catch (error) {
            console.error('Error:', error); 
            alert('An error occurred while getting the reports.');
        }

    });


    if (!token) {
        return <Navigate to="/"/>
    }

    const handleToggle = () => {
        setExpanded(!expanded);
        onToggle();
    };

    return (
        <div style={{ minWidth:expanded?260:'',paddingTop:'55px' ,height:'100%',boxShadow:'0px 0 2px rgb(1, 138, 143)',borderRight:'1px solid rgb(21, 255, 169)',}}>

            <Sidenav   className='Sidenav' expanded={expanded} defaultOpenKeys={['3', '4']}>
                <Sidenav.Body className='sidenav_body' style={{overflowY:'scroll'}}>
                    <div className='logoVille'>
                        <span><FaCity size={25}/></span>
                        <span style={{display:expanded?'inline':'none',fontWeight:'bold'}}>Ville de Meknès</span><br />
                    </div>
                    <center>
                        {
                            temp&&(
                                <>
                                    <p style={{
                                        display:expanded? 'inline':'none',
                                        marginBottom: '10px',
                                        // display: 'none'
                                    }}><strong >{temp}</strong></p>
                                    <p style={{
                                        display:expanded?'none':'inline',
                                        marginBottom: '10px',
                                        // display: 'none'
                                    }}><strong >{temp.split('/')[0].charAt(0)}/{temp.split('/')[1].charAt(0)}</strong></p>
                                </>
                            )
                        }
                        <Divider sx={{width:'90%'}}/>
                    </center>
                    <Nav  activeKey={activeKey} style={{display:'flex',gap:55,flexDirection:'column',overflowX:'hidden'}} onSelect={setActiveKey}>
                        {
                            hasPermission(user.permissions, 'dashboard', 'read')&&(
                                <NavLink to={'/dashboard/home/dashboard'} eventKey="1" className='dash_links' style={{marginTop:'10px',width:'100%',display:'flex',alignItems:'center',height:'50px'}}
                                    onClick={()=>!expanded?handleToggle():true}
                                >
                                    <span style={{width:!expanded?'100%':'28%',display:'flex',alignItems:'center',justifyContent:'center'}}><MdDashboard  size={24}/></span> 
                                    <span style={{ width: '90%' ,display:expanded?'inline':'none'}} >{t('dashboard')}</span> 
                                </NavLink>
                            )
                        }
                        <div style={{width:'100%',display:'flex'}}>
                            <Nav style={{
                                width:'100%',
                                display:'flex',
                                alignItems:'center',
                                // background:'transparent'
                            }} 
                            >
                                {
                                    hasPermission(user.permissions, 'user_management', 'read')&&(
                                        <Nav.Menu
                                        
                                        onClick={()=>!expanded?handleToggle():true}
                                        style={{
                                            position:expanded?'relative':'absolute',
                                            right:0,
                                            zIndex:1000000,
                                            fontWeight:'bold',
                                            
                                        }} title={t("users.users")}  
                                        icon={<Us size={24} style={{position:'absolute',left:expanded?'21px':'18px'}}/>} placement={expanded ? "rightStart" : "rightEnd"}>
                                            <Nav.Item eventKey="4" className='Dropdown_item_workspace'>
                                                <NavLink to='/dashboard/SuperAdmin/AllUsers' className='workspace_links' >
                                                    <FaUsers size={20}  style={{marginRight:'10px'}}/>
                                                    <span>
                                                        {t("users.allUsers")}
                                                    </span>
                                                </NavLink>
                                            </Nav.Item>
                                            <Nav.Item eventKey="1" className='Dropdown_item_workspace'>
                                                <NavLink to='/dashboard/SuperAdmin/Permissions' className='workspace_links' >
                                                    <FaUserShield size={20}   style={{marginRight:'10px'}}/>
                                                        <span>
                                                            {t("users.permissions")}
                                                        </span>
                                                </NavLink>
                                            </Nav.Item>
                                        </Nav.Menu>
                                    )
                                }
                            </Nav>
                        </div>
                        {/* workspaces */}
                        <div style={{width:'100%',display:'flex'}}>
                            <Nav style={{
                                width:'100%',
                                color:'rgb(71, 71, 71)',
                                display:'flex',
                                alignItems:'center'
                            }} 
                            
                            >
                                <Dropdown style={{fontWeight:'bold'}} onClick={()=>!expanded?handleToggle():true}  title={t("users.workspaces")} icon={<MdWorkspacesFilled size={24} style={{position:'absolute',left:expanded?'21px':'18px'}}/>} placement="rightStart">
                                {
                                    hasPermission(user.permissions, 'workspaces', 'read')&&(
                                        user.role==="superadmin"?(
                                            <Dropdown.Item eventKey="5"  className='Dropdown_item_workspace'>
                                                <NavLink to='/dashboard/SuperAdmin/Workspaces' className='workspace_links'>
                                                    <MdWorkspacesFilled size={20}  style={{marginRight:'10px'}}/>
                                                    <span>
                                                        {t("users.allWorkspaces")}
                                                    </span>
                                                </NavLink>
                                            </Dropdown.Item>
                                        ):(
                                            <Dropdown.Item eventKey="5"  className='Dropdown_item_workspace'>
                                                <NavLink to={`/dashboard/Workspaces`} className='workspace_links'>
                                                    <MdWorkspacesFilled size={20}  style={{marginRight:'10px'}}/>
                                                    <span>
                                                        {t("users.allWorkspaces")}
                                                    </span>
                                                </NavLink>
                                            </Dropdown.Item>
                                        )
                                    )
                                }
                                {
                                    hasPermission(user.permissions, 'sites', 'read')&&(
                                        (user?.role==='superadmin'||user?.role==='admin'||user?.role==='manager')?(
                                            <Dropdown.Item eventKey="7"  className='Dropdown_item_workspace'>
                                                <NavLink to='/dashboard/SuperAdmin/Sites' className='workspace_links' >
                                                    <SiTestcafe size={20}  style={{marginRight:'10px'}}/>
                                                    <span>
                                                        {t("users.allSites")}
                                                    </span>
                                                </NavLink>
                                            </Dropdown.Item>
                                        ):(
                                            <Dropdown.Item eventKey="7"  className='Dropdown_item_workspace'>
                                                <NavLink to='/dashboard/Sites' className='workspace_links' >
                                                    <SiTestcafe size={20}  style={{marginRight:'10px'}}/>
                                                    <span>
                                                        {t("users.allSites")}
                                                    </span>
                                                </NavLink>
                                            </Dropdown.Item>
                                        )
                                    )
                                }
                                {
                                    hasPermission(user.permissions, 'buildings', 'read')&&(
                                        (user?.role==='superadmin'||user?.role==='admin'||user?.role==='manager')?(
                                            <Dropdown.Item eventKey="8"  className='Dropdown_item_workspace'>
                                                <NavLink to='/dashboard/SuperAdmin/Buildings' className='workspace_links' >
                                                    <BsFillBuildingsFill size={20}  style={{marginRight:'10px'}}/>
                                                    <span>
                                                        {t("users.allBuildings")}
                                                    </span>
                                                </NavLink>
                                            </Dropdown.Item>
                                        ):(
                                            <Dropdown.Item eventKey="8"  className='Dropdown_item_workspace'>
                                                <NavLink to='/dashboard/Buildings' className='workspace_links' >
                                                    <BsFillBuildingsFill size={20}  style={{marginRight:'10px'}}/>
                                                    <span>
                                                        {t("users.allBuildings")}
                                                    </span>
                                                </NavLink>
                                            </Dropdown.Item>
                                        )
                                    )
                                }
                                {
                                    hasPermission(user.permissions, 'components', 'read')&&(
                                        (user?.role==='superadmin'||user?.role==='admin'||user?.role==='manager')?(
                                            <Dropdown.Item eventKey="8"  className='Dropdown_item_workspace'>
                                                <NavLink to='/dashboard/SuperAdmin/Components' className='workspace_links' >
                                                    <CgComponents size={20}  style={{marginRight:'10px'}}/>
                                                    <span>
                                                        {t("users.allComponents")}
                                                    </span>
                                                </NavLink>
                                            </Dropdown.Item>
                                        ):(
                                            <Dropdown.Item eventKey="8"  className='Dropdown_item_workspace'>
                                                <NavLink to='/dashboard/Components' className='workspace_links' >
                                                    <CgComponents size={20}  style={{marginRight:'10px'}}/>
                                                    <span>
                                                        {t("users.allComponents")}
                                                    </span>
                                                </NavLink>
                                            </Dropdown.Item>
                                        )
                                    )
                                }
                                {
                                    hasPermission(user.permissions, 'incidents', 'read')&&(
                                        <Dropdown.Item eventKey="8"  className='Dropdown_item_workspace'>
                                            <NavLink to='/dashboard/SuperAdmin/Incidents' className='workspace_links' >
                                                <BsBuildingX size={20}  style={{marginRight:'10px'}}/>
                                                <span>
                                                    {t("users.allIncidents")}
                                                </span>
                                            </NavLink>
                                        </Dropdown.Item>
                                    )
                                }
                                {
                                    hasPermission(user.permissions, 'reports', 'read')&&(
                                        <Dropdown.Item eventKey="8"  className='Dropdown_item_workspace'>
                                            <NavLink to='/dashboard/SuperAdmin/Reports' className='workspace_links' >
                                                <TbReportAnalytics size={20}  style={{marginRight:'10px'}}/>
                                                <span> 
                                                    {t("users.allReports")}
                                                </span>
                                            </NavLink>
                                        </Dropdown.Item>
                                    )
                                }
                                </Dropdown>
                            </Nav>
                        </div>

                        {/* Analytics */}
                        <div style={{width:'100%',display:'flex'}}>
                            <Nav style={{
                                width:'100%',
                                color:'rgb(71, 71, 71)',
                                display:'flex',
                                alignItems:'center'
                            }} 
                            
                            >
                                <Dropdown style={{fontWeight:'bold'}} onClick={()=>!expanded?handleToggle():true} title={t("users.analytics")} icon={<FiBarChart2 size={24} style={{position:'absolute',left:expanded?'21px':'18px'}}/>} placement="rightStart">
                                    <Dropdown.Item eventKey="1" className='Dropdown_item_workspace'>
                                        <NavLink to='/dashboard/SuperAdmin/Analytics' className='workspace_links' >
                                            <MdAutoFixHigh size={20}  style={{marginRight:'10px'}}/>
                                            <span>
                                                {t("users.analytics")}
                                            </span>
                                        </NavLink>
                                    </Dropdown.Item>
                                </Dropdown>
                            </Nav>
                        </div>

                        {/* AUDITS */}
                            <div style={{width:'100%',display:'flex'}}>
                                <Nav style={{
                                    width:'100%',
                                    color:'rgb(71, 71, 71)',
                                    display:'flex',
                                    alignItems:'center'
                                }} 
                                
                                >
                                    <Dropdown style={{fontWeight:'bold'}} onClick={()=>!expanded?handleToggle():true} title={t("audits")} icon={<AiOutlineAudit size={24} style={{position:'absolute',left:expanded?'21px':'18px'}}/>} placement="rightStart">
                                    {
                                        hasPermission(user.permissions,'audits','create')&&(
                                            <Dropdown.Item eventKey="1" className='Dropdown_item_workspace'>
                                                <NavLink to='/dashboard/Add_Audits' className='workspace_links' >
                                                    <GrCompliance size={20}  style={{marginRight:'10px'}}/>
                                                    <span>
                                                        {t("Add_audits")}
                                                    </span>
                                                </NavLink>
                                            </Dropdown.Item>
                                        )
                                    }
                                    {
                                        hasPermission(user.permissions,'audits','read')&&(
                                            <Dropdown.Item eventKey="1" className='Dropdown_item_workspace'>
                                                <NavLink to='/dashboard/Audits' className='workspace_links' >
                                                    <LuGalleryHorizontalEnd size={20}  style={{marginRight:'10px'}}/>
                                                    <span>
                                                        {t("audits")}
                                                    </span>
                                                </NavLink>
                                            </Dropdown.Item>
                                        )
                                    }
                                    {
                                        hasPermission(user.permissions,'deviations','read')&&(
                                            <Dropdown.Item eventKey="1" className='Dropdown_item_workspace'>
                                                <NavLink to='/dashboard/Deviations' className='workspace_links' >
                                                    <PiSpinnerGapBold size={20}  style={{marginRight:'10px'}}/>
                                                    <span>
                                                        {t("DD")}
                                                    </span>
                                                </NavLink>
                                            </Dropdown.Item>
                                        )
                                    }
                                    {
                                        hasPermission(user.permissions,'corrective_actions','read')&&(
                                            <Dropdown.Item eventKey="1" className='Dropdown_item_workspace'>
                                                <NavLink to='/dashboard/Corrective_actions' className='workspace_links' >
                                                    <PiSpinnerGapBold size={20}  style={{marginRight:'10px'}}/>
                                                    <span>
                                                        Corrective actions
                                                    </span>
                                                </NavLink>
                                            </Dropdown.Item>
                                        )
                                    }
                                    </Dropdown>
                                </Nav>
                            </div>


                        {/* Services & occupants & .... */}
                            {
                                hasPermission(user.permissions, 'services', 'read')&&(
                                    <div style={{width:'100%',display:'flex'}}>
                                        <Nav style={{
                                            width:'100%',
                                            color:'rgb(71, 71, 71)',
                                            display:'flex',
                                            alignItems:'center'
                                        }} 
                                        
                                        >
                                                    <Dropdown style={{fontWeight:'bold'}} onClick={()=>!expanded?handleToggle():true} title={t('SR')} icon={<MdOutlineMiscellaneousServices size={24} style={{position:'absolute',left:expanded?'21px':'18px'}}/>} placement="rightStart">
                                                        <Dropdown.Item eventKey="1" className='Dropdown_item_workspace'>
                                                            <NavLink to='/dashboard/home/DashboardServicesMain' className='workspace_links' >
                                                                <MdOutlineMiscellaneousServices size={20}  style={{marginRight:'10px'}}/>
                                                                <span>
                                                                    {t('SRD')}
                                                                </span>
                                                            </NavLink>
                                                        </Dropdown.Item>
                                                    </Dropdown>
                                        </Nav>
                                    </div>
                                )
                            }

                            {/* Investments 
                            
                            o	InvestmentDashboard.js
                            o	ProjectTrackingTable.js
                            o	DetailedReportPage.js
                            o	CapitalPlanning.js
                            o	ExpenseTrackingForm.js

                            */}
                            {
                                hasPermission(user.permissions, 'investments', 'read')&&(
                                    <div style={{width:'100%',display:'flex'}}>
                                        <Nav style={{
                                            width:'100%',
                                            color:'rgb(71, 71, 71)',
                                            display:'flex',
                                            alignItems:'center'
                                        }} 
                                        
                                        >
                                            <Dropdown style={{fontWeight:'bold'}} onClick={()=>!expanded?handleToggle():true} title={t("SI")} icon={<MdOutlineAttachMoney size={24} style={{position:'absolute',left:expanded?'21px':'18px'}}/>} placement="rightStart">
                                                {
                                                    hasPermission(user.permissions, 'investments_dashboard', 'read')&&(
                                                        <Dropdown.Item eventKey="1" className='Dropdown_item_workspace'>
                                                            <NavLink to='/dashboard/home/investment_dashboard' className='workspace_links' >
                                                                <GiTakeMyMoney size={20}  style={{marginRight:'10px'}}/>
                                                                <span>
                                                                    {t('IDASH')} 
                                                                </span>
                                                            </NavLink>
                                                        </Dropdown.Item>
                                                    )
                                                }
                                                {/* {
                                                    hasPermission(user.permissions, 'budget_planning', 'read')&&(
                                                        <Dropdown.Item eventKey="1" className='Dropdown_item_workspace'>
                                                            <NavLink to='/dashboard/home/budget_planning' className='workspace_links' >
                                                                <GiMoneyStack size={20}  style={{marginRight:'10px'}}/>
                                                                <span>
                                                                    {t('IBM')}
                                                                </span>
                                                            </NavLink>
                                                        </Dropdown.Item>
                                                    )
                                                } */}
                                                
                                                {
                                                    hasPermission(user.permissions, 'financial', 'read')&&(
                                                        <Dropdown.Item eventKey="1" className='Dropdown_item_workspace'>
                                                            <NavLink to='/dashboard/home/financial_reports_dashboard' className='workspace_links' >
                                                                <TbBusinessplan size={20}  style={{marginRight:'10px'}}/>
                                                                <span>
                                                                    {t('FDASH')}
                                                                </span>
                                                            </NavLink>
                                                        </Dropdown.Item>
                                                    )
                                                }
                                                {
                                                    hasPermission(user.permissions, 'investments_tracking', 'read')&&(
                                                        <Dropdown.Item eventKey="1" className='Dropdown_item_workspace'>
                                                            <NavLink to='/dashboard/home/investments_tracking' className='workspace_links' >
                                                                <GiExpense size={20}  style={{marginRight:'10px'}}/>
                                                                <span>
                                                                    Investments tracking
                                                                </span>
                                                            </NavLink>
                                                        </Dropdown.Item>
                                                    )
                                                }
                                            </Dropdown>
                                        </Nav>
                                    </div>
                                )
                            }
                            {/* promotion immobilier */}
                            {
                                hasPermission(user.permissions, 'promotions', 'read')&&(
                                    <div style={{width:'100%',display:'flex'}}>
                                        <Nav style={{
                                            width:'100%',
                                            color:'rgb(71, 71, 71)',
                                            display:'flex',
                                            alignItems:'center'
                                        }} 
                                        
                                        >
                                            <Dropdown style={{fontWeight:'bold'}} onClick={()=>!expanded?handleToggle():true} title={t("PRMI")} icon={<MdConstruction size={24} style={{position:'absolute',left:expanded?'21px':'18px'}}/>} placement="rightStart">
                                                {
                                                    hasPermission(user.permissions, 'construction_phases', 'read')&&(
                                                        <Dropdown.Item eventKey="1" className='Dropdown_item_workspace'>
                                                            <NavLink to='/dashboard/home/construction_phases' className='workspace_links' >
                                                                <GiDuration size={20}  style={{marginRight:'10px'}}/>
                                                                <span>
                                                                {t('CPHA')}

                                                                </span>
                                                            </NavLink>
                                                        </Dropdown.Item>
                                                    )
                                                }
                                                {
                                                    hasPermission(user.permissions, 'milestones', 'read')&&(
                                                        <Dropdown.Item eventKey="1" className='Dropdown_item_workspace'>
                                                            <NavLink to='/dashboard/home/milestones' className='workspace_links' >
                                                                <VscMilestone size={20}  style={{marginRight:'10px'}}/>
                                                                <span>
                                                                {t('MLSN')}
                                                                </span>
                                                            </NavLink>
                                                        </Dropdown.Item>
                                                    )
                                                }
                                                {
                                                    hasPermission(user.permissions, 'calender_projects', 'read')&&(
                                                        <Dropdown.Item eventKey="1" className='Dropdown_item_workspace'>
                                                            <NavLink to='/dashboard/home/calender_projects_construction' className='workspace_links' >
                                                                <LuCalendarCheck2 size={20}  style={{marginRight:'10px'}}/>
                                                                <span>
                                                                    {t('PCLDR')}
                                                                </span>
                                                            </NavLink>
                                                        </Dropdown.Item>
                                                    )
                                                }
                                                {
                                                    hasPermission(user.permissions, 'reservations', 'read')&&(
                                                        <Dropdown.Item eventKey="1" className='Dropdown_item_workspace'>
                                                            <NavLink to='/dashboard/home/reservations' className='workspace_links' >
                                                                <SiMockserviceworker size={20}  style={{marginRight:'10px'}}/>
                                                                <span>
                                                                    {t('res')}
                                                                </span>
                                                            </NavLink>
                                                        </Dropdown.Item>
                                                    )
                                                }
                                                {
                                                    hasPermission(user.permissions, 'corrections', 'read')&&(
                                                        <Dropdown.Item eventKey="1" className='Dropdown_item_workspace'>
                                                            <NavLink to='/dashboard/home/corrections' className='workspace_links' >
                                                                <TbSettingsCheck size={20}  style={{marginRight:'10px'}}/>
                                                                <span>
                                                                    {t('cor')}
                                                                </span>
                                                            </NavLink>
                                                        </Dropdown.Item>
                                                    )
                                                }
                                                {
                                                    hasPermission(user.permissions, 'correction_actions', 'read')&&(
                                                        <Dropdown.Item eventKey="1" className='Dropdown_item_workspace'>
                                                            <NavLink to='/dashboard/home/actions' className='workspace_links' >
                                                                <SiGithubactions size={20}  style={{marginRight:'10px'}}/>
                                                                <span>
                                                                    {t('actions')}
                                                                </span>
                                                            </NavLink>
                                                        </Dropdown.Item>
                                                    )
                                                }
                                                {
                                                    hasPermission(user.permissions, 'deliveries', 'read')&&(
                                                        <Dropdown.Item eventKey="1" className='Dropdown_item_workspace'>
                                                            <NavLink to='/dashboard/home/deliveries' className='workspace_links' >
                                                                <TbTruckDelivery size={20}  style={{marginRight:'10px'}}/>
                                                                <span>
                                                                    {t('DLV')}
                                                                </span>
                                                            </NavLink>
                                                        </Dropdown.Item>
                                                    )
                                                }
                                            </Dropdown>
                                        </Nav>
                                    </div>
                                )
                            }
                        {
                            hasPermission(user.permissions,'maintenance_tasks','read')&&(
                                <div style={{width:'100%',display:'flex'}}>
                                    <Nav style={{
                                        width:'100%',
                                        color:'rgb(71, 71, 71)',
                                        display:'flex',
                                        alignItems:'center'
                                    }} 
                                    >
                                        <Dropdown style={{fontWeight:'bold'}} onClick={()=>!expanded?handleToggle():true} title={t('maintenancesPage.tasks')} icon={<FaTasks size={24} style={{position:'absolute',left:expanded?'21px':'18px'}}/>} placement="rightStart">
                                            {
                                                hasPermission(user.permissions,'task_management','create')&&(
                                                    <Dropdown.Item eventKey="1" className='Dropdown_item_workspace'>
                                                        <NavLink to='/dashboard/SuperAdmin/assignTasks' className='workspace_links' >
                                                            <FaTasks size={20}  style={{marginRight:'10px'}}/>
                                                            <span>
                                                                {t("maintenancesPage.assign")}
                                                            </span>
                                                        </NavLink>
                                                    </Dropdown.Item>
                                                )
                                            }
                                            {
                                                hasPermission(user.permissions,'maintenance_tasks','create')&&(
                                                    <Dropdown.Item eventKey="1" className='Dropdown_item_workspace'>
                                                        <NavLink to='/dashboard/SuperAdmin/maintenanceTasks' className='workspace_links' >
                                                            <GrVmMaintenance size={20} style={{marginRight:'10px'}}/>
                                                            <span>
                                                                {t("maintenancesPage.maintenanceT")}
                                                            </span>
                                                        </NavLink>
                                                    </Dropdown.Item>
                                                )
                                            }
                                            {
                                            
                                            }
                                            <Dropdown.Item eventKey="1" className='Dropdown_item_workspace'>
                                                <NavLink to='/dashboard/SuperAdmin/AllMaintenanceTasks' className='workspace_links' >
                                                    <IoMdDoneAll size={20} style={{marginRight:'10px'}}/>
                                                    <span>
                                                        {t("maintenancesPage.allMaintenanceT")}
                                                    </span>
                                                </NavLink>
                                            </Dropdown.Item>
                                            {/* New */}
                                            <Dropdown.Item eventKey="1" className='Dropdown_item_workspace'>
                                                <NavLink to='/dashboard/SuperAdmin/MaintenancePlanning' className='workspace_links' >
                                                    <RiCalendarScheduleLine size={20} style={{marginRight:'10px'}}/>
                                                    <span>
                                                        {t('MP')}
                                                    </span>
                                                </NavLink>
                                            </Dropdown.Item>
                                            {/* New */}
                                        </Dropdown>
                                    </Nav>
                                </div>
                            )
                        }
                        {
                            hasPermission(user.permissions, 'settings', 'read')&&(
                                <div style={{width:'100%',display:'flex'}}>
                                    <Nav style={{
                                        width:'100%',
                                        color:'rgb(71, 71, 71)',
                                        display:'flex',
                                        alignItems:'center'
                                    }} 
                                    
                                    >
                                        <Dropdown style={{fontWeight:'bold'}} onClick={()=>!expanded?handleToggle():true} title={t("users.settings")} icon={<IoSettings size={24} style={{position:'absolute',left:expanded?'21px':'18px'}}/>} placement="rightStart">
                                            <Dropdown.Item eventKey="1" className='Dropdown_item_workspace'>
                                                <NavLink to='/dashboard/SuperAdmin/Settings' className='workspace_links' >
                                                <IoSettings size={20} style={{marginRight:'10px'}}/>
                                                <span>
                                                    {t("users.settings")}
                                                </span>
                                                </NavLink>
                                            </Dropdown.Item>
                                        </Dropdown>
                                    </Nav>
                                </div>
                            )
                        }
                    </Nav>
                </Sidenav.Body>
                <Sidenav.Toggle  onToggle={handleToggle} style={{width:'100%'}}/>
            </Sidenav>
        </div>
    );
}
